export default __webpack_public_path__ + "f9733a8679f559f0b9d7275a1c952296.ttf";